
export default function validate({ brand, setErrors }) {
  const validationErrors = []

  if (brand.customHomepageUrl && !isValidURL(brand.customHomepageUrl)) {
    validationErrors['customHomepageUrl'] = 'Please enter a valid URL (including http:// or https://) for the Home webpage URL'
  }

  setErrors(validationErrors)
}


function isValidURL(string) {
    try {
        const url = new URL(string)
        return ['http:', 'https:'].includes(url.protocol) && !!url.hostname
    } catch (_) {
        return false
    }
}